import { render, staticRenderFns } from "./ManageUserRoles.vue?vue&type=template&id=883dfa70"
import script from "./ManageUserRoles.vue?vue&type=script&lang=js"
export * from "./ManageUserRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports